// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2ysg3","subheader":"ReorderModal_subheader__3SpJA","listWrap":"ReorderModal_listWrap__FT2TW"};